import { ICustomerDetail, ISetCustomerData } from "@interfaces";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { redeemerApi } from "src/Api/redeemers";
import { RootState } from ".";

interface RedeemerState {
    redeemer: ICustomerDetail[];
}

const initialState: RedeemerState = {
    redeemer: [],
};

export const fetchRedeemer = createAsyncThunk<ICustomerDetail[]>(
    "redeemer/fetchRedeemer",
    async (_, { rejectWithValue }) => {
        try {
            const response = await redeemerApi.getRedeemer();
            return response.data.data as ICustomerDetail[];
        } catch (error) {
            console.error("Failed to fetch redeemers:", error);
            return rejectWithValue("Unable to fetch redeemer data.");
        }
    },
);

export const createNewRedeemer = createAsyncThunk<ICustomerDetail, ISetCustomerData>(
    "customer/createNewRedeemer",
    async (newCartItem, { rejectWithValue }) => {
        try {
            const createReaponse = await redeemerApi.AddRedeemer(newCartItem);
            return createReaponse.data.data as ICustomerDetail;
        } catch (error: any) {
            console.error("Failed to update customer or fetch customer data:", error);
            return rejectWithValue(error.response?.data || error.message);
        }
    },
);

const redeemerSlice = createSlice({
    name: "redeemer",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchRedeemer.fulfilled, (state, action) => {
                state.redeemer = action.payload;
            })
            .addCase(fetchRedeemer.rejected, (state, action) => {
                console.error("Failed to update redeemers", action.payload);
            })
            .addCase(createNewRedeemer.rejected, (_state, action) => {
                console.error("Failed to create new redeemers", action.payload);
            });
    },
});

export const selectRedeemer = (state: RootState) => state.redeemer;

export default redeemerSlice.reducer;
